export const loginState = {
  //'Du er en hjelpsom assistent som svarer kort og konsist på norsk.',
  isAuthenticated: false,
  isInitialized: false,
  isLoggedIn: '',
  userName: '',
  userEmail: '',
  microsoftLogin: null,
  loginType: '',
  googleLogin: null,
  adminuserInfo: null,
  interactionInProgress: false,
  accesstoken: null,
  idtoken: null
}
